// Moved verbatim from `src/hooks/query/notFoundSessionIds.ts` (which
// re-exports from here) with the D3 family: the shared 404 short-circuit so
// downstream session queries (permissions, transcript, document,
// live-transcript) stop refetching a deleted session.
const notFoundSessions = new Set<string>();

export const notFoundSessionIds = {
  add: (sessionId: string) => notFoundSessions.add(sessionId),
  has: (sessionId: string) => notFoundSessions.has(sessionId),
  remove: (sessionId: string) => notFoundSessions.delete(sessionId),
  clear: () => notFoundSessions.clear(),
  size: () => notFoundSessions.size,
};
